import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const supplierLogos = [
  { id: 1, name: "Rexel", image: "https://customer-assets.emergentagent.com/job_d0850d40-f350-4ecf-87ac-4e2d9723d534/artifacts/czxa06ll_Rexel.png" },
  { id: 2, name: "GSA Systems", image: "https://customer-assets.emergentagent.com/job_d0850d40-f350-4ecf-87ac-4e2d9723d534/artifacts/2gmq6rl6_GSA%20sustems%20logo.webp" },
  { id: 3, name: "AWM", image: "https://customer-assets.emergentagent.com/job_d0850d40-f350-4ecf-87ac-4e2d9723d534/artifacts/fb12zmo2_AWM_RGB_1.png" },
  { id: 4, name: "Wesco Anixter", image: "https://customer-assets.emergentagent.com/job_d0850d40-f350-4ecf-87ac-4e2d9723d534/artifacts/w7v8q46d_wesco-anixter-logo-01.webp" },
  { id: 5, name: "Seadan", image: "https://customer-assets.emergentagent.com/job_d0850d40-f350-4ecf-87ac-4e2d9723d534/artifacts/r6wf44dy_seadan.png" },
];

const ClientLogos = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        '.client-logo',
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          stagger: 0.1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 85%',
            toggleActions: 'play none none reverse',
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="py-16 bg-white relative overflow-hidden">
      {/* Top Line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-securelec-red/30 to-transparent" />
      
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-securelec-gray/60 text-sm font-medium tracking-widest uppercase">
            Our Trusted Suppliers
          </span>
        </div>

        {/* Logos Grid */}
        <div className="flex flex-wrap items-center justify-center gap-10 md:gap-16">
          {supplierLogos.map((supplier) => (
            <div
              key={supplier.id}
              className="client-logo group relative"
            >
              <div className="h-12 flex items-center justify-center grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-300">
                <img 
                  src={supplier.image} 
                  alt={supplier.name}
                  className="h-full w-auto max-w-[140px] object-contain"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-securelec-red/30 to-transparent" />
    </section>
  );
};

export default ClientLogos;
